import apiClient from "../config/apiClient";


export const fetchAllergies = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=patient-allergens?patient_id=${id}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  







// /patient-allergens?patient_id=19957